import React from 'react'
import CustomCard from '../../modules/custom_card'
import CustomSkelton from '../../modules/custom_skelton/custom_skelton'
import styles from './show_card_handler.module.css'

export default function ShowCardsHandler(props) {

    const dataHandler = (data, index) => {
        return (
            <div key={index} >
                {
                    <CustomCard data={data} />
                }
            </div>
        )
    }

    if (props.appData === undefined ||
        props.appData.length === 0)
        return (
            <div className={styles.skelton}>
                <CustomSkelton />
            </div>
        )

    return (
        /*    <Grid container>
               {
               }
               </Grid> */
        <div className={styles.map_container}>
            {props.appData.map(dataHandler)}
        </div>
    )
}